/* eslint-disable react/jsx-no-duplicate-props */
import React from 'react'
import PropTypes from 'prop-types'
import { SearchIcon } from '@sainsburys-tech/bolt-icons'
import * as Styled from './SearchBar.styles'

const SearchBar = ({
  className,
  submitElement,
  hasIcon,
  onSubmit,
  onChange,
  'data-test': dataTest,
  kind = 'primary',
  value = '',
  ...props
}) => {
  const submitSearchTerm = evt => {
    evt.preventDefault()
    onSubmit(value)
  }

  return (
    <Styled.SearchBar className={className} data-test={dataTest} onSubmit={submitSearchTerm}>
      <Styled.SearchInput
        type='text'
        aria-label='Search'
        value={value}
        onChange={onChange}
        name='search'
        autoComplete='false'
        {...props}
      />
      <Styled.ButtonContainer>
        <Styled.SearchButton type='submit' value='Submit' kind={kind} data-test={`${dataTest}-search-button`}>
          {hasIcon ? (
            <Styled.SearchIconContainer>
              <SearchIcon width={24} height={24} />
              <span className='sr-only'>Search Button</span>
            </Styled.SearchIconContainer>
          ) : (
            submitElement
          )}
        </Styled.SearchButton>
      </Styled.ButtonContainer>
    </Styled.SearchBar>
  )
}

SearchBar.displayName = 'SearchBar'

SearchBar.propTypes = {
  /**
   * Specify an optional className to be added to your Search Bar
   */
  className: PropTypes.string,

  /**
   * Specify an optional data-test attribute to be added to your Search Bar for e2e testing
   */
  'data-test': PropTypes.string,

  /**
   * Specify the submit callback function
   */
  onSubmit: PropTypes.func,

  /**
   * Specify a mandatory callback for the input field's onChange event
   */
  onChange: PropTypes.func,

  /**
   * Display search icon instead of submitElement
   */
  hasIcon: PropTypes.bool,

  /**
   * Specify the content of your submit element
   */
  value: PropTypes.string,

  /**
   * Specify the content of the submitElement
   */
  submitElement: PropTypes.node,

  /**
   * Specify the value of the placeholder
   */
  placeholder: PropTypes.string,

  /**
   * Specify kind of search bar button
   */
  kind: PropTypes.oneOf(['primary', 'secondary'])
}

SearchBar.defaultProps = {
  hasIcon: false,
  submitElement: 'Search',
  placeholder: '',
  kind: 'primary',
  onSubmit: () => {},
  onChange: () => {},
  'data-test': 'component-searchbar'
}

export default SearchBar
